import { useState } from "react";

import Button from "@stadium/shared/src/components/shared/button";

import SearchModal from "./modal";

import styles from "./main.module.scss";

const SearchModalWithTrigger = () => {
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <Button
        styleType="no-style"
        className={styles.iconButton}
        onClick={() => {
          setShowModal(true);
        }}
      >
        <span className={styles.searchIcon} />
      </Button>
      {showModal && <SearchModal closeModal={handleCloseModal} />}
    </>
  );
};

export default SearchModalWithTrigger;
